import "../../../styles/requests.css";
import {
  convertTo12HourPlusDateFormat,
  formatToPeso,
} from "../../../util/helperFunctions";

function CCARItem({ data }) {
  const handleViewBtnClick = (link_id, request_type) => {
    window.location.href = `/requests?p=view-request-detail&t=${request_type}&r=${link_id}`;
  };

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return "approved";

      case "denied":
        return "denied";

      case "cancelled":
        return "cancelled";

      case "pending":
      default:
        return "pending";
    }
  };

  const status = data?.final_status || "Pending";

  return (
    <div
      className="request-item--list-container"
      onClick={() =>
        handleViewBtnClick(data?.request_link_id, data?.request_type)
      }
    >
      <div className="request-item--row">
        <div className="request--item-logo">
          <i
            className="fa fa-file-text-o fa-4x"
            aria-hidden="true"
          ></i>
        </div>

        <div>
          <div className="request-ref-no">
            <h1>{data?.reference_id}</h1>
          </div>

          <div className="request--detail">
            <div className="request--detail-item">
              <span>Employee:&nbsp;</span>
              <span>{data?.user_detail?.display_name}</span>
            </div>

            <div className="request--detail-item">
              <span>Request Type:&nbsp;</span>
              <span>{data?.request_type}</span>
            </div>

            <div className="request--detail-item">
              <span>Date & Time Requested:&nbsp;</span>
              <span>
                {convertTo12HourPlusDateFormat(data?.createdAt)}
              </span>
            </div>

            <div className="request--detail-item">
              <span>Total Cost:&nbsp;</span>
              <span>{formatToPeso(data?.total_cost)}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="request--detail-status">
        <div
          className={`status ${getStatusClass(
            status
          )} request--item-approval-status`}
        >
          <span>{status}</span>
        </div>
      </div>
    </div>
  );
}

export default CCARItem;